import {
  AppBar,
  Button,
  Dialog,
  Grid,
  Toolbar,
  Typography,
} from "@mui/material";

import { FileUpload } from "./uploadFile";
import { useListaCboService } from "../../../../../../../../use-cases/geo-veles/lista-cbo";
import { useAppSelector } from "../../../../../../../hooks/store-hooks";
import { Transition } from "../../../../../../../components";

export const ListaCboImportFile = () => {
  const { listaCbo } = useAppSelector((state: any) => state);

  const { processCboFile, openImportFileListaCbos, resetListaCbosFileData, openPreviewListaCbo } =
    useListaCboService();

  const handleFileProcessed = (data: { codigo: string }[]) => {
    processCboFile(data); 
    openImportFileListaCbos(false);
    // Abre o preview após processar o arquivo
    openPreviewListaCbo(true);
  };
  return (
    <>
      <Dialog
        fullWidth
        maxWidth="xl"
        open={listaCbo.openImportFileListaCbo}
        TransitionComponent={Transition}
        onClose={() => {
          openImportFileListaCbos(false);
          resetListaCbosFileData();
        }}
      >
        <AppBar sx={{ position: "relative" }}>
          <Toolbar>
            <Typography
              sx={{ ml: 2, flex: 1 }}
              textTransform="uppercase"
              variant="h6"
            >
              Importar lista de CBOs
            </Typography>
            <Button
              color="inherit"
              onClick={() => openImportFileListaCbos(false)}
            >
              Fechar
            </Button>
          </Toolbar>
        </AppBar>
        <Grid container spacing={3} sx={{ p: 3 }}>
          <Grid item xs={12}>
            <FileUpload
              label="Clique ou arraste um arquivo .csv, .txt ou .xlsx com códigos CBO"
              onFileProcessed={handleFileProcessed}
              onError={(error) => {
                console.error("Erro no upload:", error);
              }}
            />
          </Grid>
        </Grid>
      </Dialog>
    </>
  );
};